var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchAlterar, fetchResource, fetchConsultarPaginada, URL_API } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
var REEDUCANDOS_PAGE_SIZE = 20;
var ROTA_BASE = 'reeducandos-pontos/justificativas';
/**
 * Busca a listagem de justificativas (web — fiscal/administrador).
 *
 * GET /reeducandos-pontos/justificativas?source=web
 * - Default: status=EM_ANALISE, mês corrente, 15 por página, ordem desc
 */
export var getJustificativas = function (pagination, filtros) { return __awaiter(void 0, void 0, Promise, function () {
    var params, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams({ source: 'web' });
                if (filtros === null || filtros === void 0 ? void 0 : filtros.nome)
                    params.append('nome', filtros.nome);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.matricula)
                    params.append('matricula', filtros.matricula);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.contrato_id)
                    params.append('contrato_id', String(filtros.contrato_id));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.status)
                    params.append('status', filtros.status);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.tipo_justificativa_id)
                    params.append('tipo_justificativa_id', String(filtros.tipo_justificativa_id));
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_inicio)
                    params.append('data_inicio', filtros.data_inicio);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.data_fim)
                    params.append('data_fim', filtros.data_fim);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.sort_by)
                    params.append('sort_by', filtros.sort_by);
                if (filtros === null || filtros === void 0 ? void 0 : filtros.sort_order)
                    params.append('sort_order', filtros.sort_order);
                url = "".concat(ROTA_BASE, "?").concat(params.toString());
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Busca os contratos disponíveis para o filtro (dropdown).
 *
 * GET /reeducandos-pontos/contracts?source=web
 */
export var getContratosJustificativas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchResource('reeducandos-pontos/contracts?source=web')];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca os tipos de justificativa para o filtro (dropdown).
 *
 * GET /reeducandos-pontos/justificativas/tipos?source=web
 */
export var getTiposJustificativa = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchResource("".concat(ROTA_BASE, "/tipos?source=web"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca a lista de reeducandos vinculados aos contratos ativos do fiscal.
 * GET /reeducandos-pontos/justificativas/reeducandos-vinculados?source=web
 *
 * Suporta paginação via headers x-pagina / x-qtd-por-pagina.
 */
export { REEDUCANDOS_PAGE_SIZE };
export var getReeducandosVinculados = function (query, pagination) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/reeducandos-vinculados?source=web");
                if (query)
                    url += "&query=".concat(encodeURIComponent(query));
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination !== null && pagination !== void 0 ? pagination : { page: 0, pageSize: REEDUCANDOS_PAGE_SIZE })];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Busca dias com ocorrências em aberto (faltas ou batidas incompletas).
 * GET /reeducandos-pontos/justificativas/pendentes?source=web&reeducando_id=...
 */
export var getDiasPendentes = function (reeducando_id, pagination) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/pendentes?source=web&reeducando_id=").concat(reeducando_id);
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination !== null && pagination !== void 0 ? pagination : { page: 0, pageSize: 50 })];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Envia a justificativa para o servidor.
 * POST /reeducandos-pontos/justificativas?source=web
 *
 * Faz o fetch diretamente para preservar o campo `details` do erro
 * (ex.: datas_referencia_conflitantes em ACTIVE_JUSTIFICATION_ALREADY_EXISTS).
 */
export var postJustificativa = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var token, response, body, datas, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                token = getTokenFromCookie();
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_BASE, "?source=web"), {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                    })];
            case 1:
                response = _d.sent();
                if (response.ok) {
                    return [2 /*return*/, { Status: 'OK' }];
                }
                _d.label = 2;
            case 2:
                _d.trys.push([2, 4, , 5]);
                return [4 /*yield*/, response.json()];
            case 3:
                body = _d.sent();
                datas = (_b = body === null || body === void 0 ? void 0 : body.details) === null || _b === void 0 ? void 0 : _b.datas_referencia_conflitantes;
                return [2 /*return*/, {
                        Status: 'ERRO',
                        Mensagem: (_c = body === null || body === void 0 ? void 0 : body.message) !== null && _c !== void 0 ? _c : 'Erro ao incluir a justificativa.',
                        error_code: body === null || body === void 0 ? void 0 : body.error_code,
                        datas_conflitantes: Array.isArray(datas) && datas.length > 0 ? datas : undefined,
                    }];
            case 4:
                _a = _d.sent();
                return [2 /*return*/, { Status: 'ERRO', Mensagem: 'Erro ao incluir a justificativa.' }];
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Busca detalhes de uma justificativa para visualização.
 * GET /reeducandos-pontos/justificativas/:id/detalhes?source=web
 */
export var getJustificativaDetalhes = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var url, resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/detalhes?source=web");
                return [4 /*yield*/, fetchResource(url)];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, resp];
        }
    });
}); };
/**
 * Busca detalhes de uma justificativa para análise (fiscal).
 * GET /reeducandos-pontos/justificativas/:id/analise?source=web
 */
export var getJustificativaAnalise = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var url, resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/analise?source=web");
                return [4 /*yield*/, fetchResource(url)];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, resp];
        }
    });
}); };
/**
 * Aprova uma justificativa.
 * PATCH /reeducandos-pontos/justificativas/:id/aprovar?source=web
 */
export var patchAprovarJustificativa = function (id, observacao) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/aprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { observacao: observacao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Reprova uma justificativa.
 * PATCH /reeducandos-pontos/justificativas/:id/reprovar?source=web
 */
export var patchReprovarJustificativa = function (id, observacao) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(id, "/reprovar?source=web");
                return [4 /*yield*/, fetchAlterar(url, { observacao: observacao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Gera a URL de download/preview de um anexo de justificativa.
 * GET /reeducandos-pontos/justificativas/:id/anexos/:anexoId/download?source=web
 *
 * O backend retorna Content-Disposition: inline para web (preview em nova aba).
 */
export var getAnexoDownloadUrl = function (justificativaId, anexoId) {
    var token = getTokenFromCookie();
    return "".concat(URL_API, "/").concat(ROTA_BASE, "/").concat(justificativaId, "/anexos/").concat(anexoId, "/download?source=web&token=").concat(token);
};
